// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let RivalIQ;
if (typeof window === 'undefined') {

    RivalIQ = {
        data: {}
    };

} else {
    RivalIQ = window.RivalIQ;
    RivalIQ.module('data', function () {});
}

(function () {
    'use strict';

    // https://docs.microsoft.com/en-us/linkedin/shared/references/reference-tables/job-function-codes
    const jobFunctionMap = {
        '-1': {
            key: 'none',
            code: '',
            description: 'None'
        },
        1: {
            code: 'acct',
            description: 'Accounting'
        },
        2: {
            code: 'admn',
            description: 'Administrative'
        },
        3: {
            code: 'cre',
            description: 'Arts and Design'
        },
        4: {
            code: 'bd',
            description: 'Business Development'
        },
        5: {
            code: 'css',
            description: 'Community & Social Services'
        },
        6: {
            code: 'cnsl',
            description: 'Consulting'
        },
        7: {
            code: 'edu',
            description: 'Education'
        },
        8: {
            code: 'eng',
            description: 'Engineering'
        },
        9: {
            code: 'ent',
            description: 'Entrepreneurship'
        },
        10: {
            code: 'finc',
            description: 'Finance'
        },
        11: {
            code: 'med',
            description: 'Healthcare Services'
        },
        12: {
            code: 'hr',
            description: 'Human Resources'
        },
        13: {
            code: 'it',
            description: 'Information Technology'
        },
        14: {
            code: 'lgl',
            description: 'Legal'
        },
        15: {
            code: 'mktg',
            description: 'Marketing'
        },
        16: {
            code: 'pr',
            description: 'Media & Communications'
        },
        17: {
            code: 'mps',
            description: 'Military & Protective Services'
        },
        18: {
            code: 'ops',
            description: 'Operations'
        },
        19: {
            code: 'prod',
            description: 'Product Management'
        },
        20: {
            code: 'ppm',
            description: 'Program & Product Management'
        },
        21: {
            code: 'buy',
            description: 'Purchasing'
        },
        22: {
            code: 'qa',
            description: 'Quality Assurance'
        },
        23: {
            code: 're',
            description: 'Real Estate'
        },
        24: {
            code: 'acad',
            description: 'Research'
        },
        25: {
            code: 'sale',
            description: 'Sales'
        },
        26: {
            code: 'supp',
            description: 'Support'
        }
    };

    // NOTE export the results, for both server and client
    if (typeof window === 'undefined') {
        module.exports = jobFunctionMap;
    } else {
        RivalIQ.data.LinkedInJobFunctionMap = jobFunctionMap;
    }

})();
